module.exports = __webpack_public_path__ + "static/media/EditBlue.33b91cb2.svg";